// frontend/src/components/dashboards/VendorDashboard.js
import React, { useState, useEffect } from "react";
import API from "../../../api";
import "./vendor.css";
import CartModal from "./CartModal";
import CheckoutModal from "./CheckoutModal";
import logo from "../../../assets/logo.png";
import SubCategorySlider from "./SubCategorySlider";
import MarketplaceProductCard from "./MarketplaceProductCard";
import {
  MapPin,
  Navigation,
  MapPinned,
  Search,
  X,
  PhoneCall,
  MessageCircle,
  Mail,
  Menu,
  Camera
} from "lucide-react";
import LocationPicker from "../../common/LocationPicker";
import BottomNavigation from "../../common/BottomNavigation";

function VendorDashboard() {
  const CATEGORIES = [
    { id: "raw", label: "Raw Materials" },
    { id: "furniture", label: "Furniture" },
    { id: "electrical", label: "Electrical" },
    { id: "plumbing", label: "Plumbing" },
    { id: "concrete", label: "Ready-Mix Concrete" },
    { id: "rental", label: "Rental Equipment" },
  ];

  const [selectedLocation, setSelectedLocation] = useState("All India");
  const [manualLocation, setManualLocation] = useState("");
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [projectLocation, setProjectLocation] = useState({
  address: "",
  city: "",
  district: "",
  state: "",
  pincode: "",
  country: "India",

  latitude: null,
  longitude: null,

  geo: {
    type: "Point",
    coordinates: []
  }
});
const [showMapPicker, setShowMapPicker] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);

const [selectedCategory, setSelectedCategory] = useState(
  searchParams.get("category") || "raw"
);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedCity, setSelectedCity] = useState("All Cities");
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState({});

  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [showAddedMsg, setShowAddedMsg] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const [checkoutCart, setCheckoutCart] = useState([]);
  const isLoggedIn = !!localStorage.getItem("token");
  const [autoLocate, setAutoLocate] = useState(false);

const loggedInUser = isLoggedIn
  ? JSON.parse(localStorage.getItem("civilink_user") || "{}")
  : {};

const [checkoutData, setCheckoutData] = useState({
  name: loggedInUser.name || "",
  email: loggedInUser.email || "",
  phone: "",
  deliveryLocation: null,
});
 // My Orders (Customer)
const [showMyOrders, setShowMyOrders] = useState(false);
const [customerOrders, setCustomerOrders] = useState([]);


  




  const fetchProducts = async () => {
  try {
    let url = "/admin/products/all";

    if (
      projectLocation.latitude &&
      projectLocation.longitude
    ) {
      url += `?lat=${projectLocation.latitude}&lng=${projectLocation.longitude}`;
    }

    const res = await API.get(url);

    setProducts(res.data);
    
  } catch (err) {
    console.error("Error loading products", err);
  }
};
  useEffect(() => {
  fetchProducts();
}, [projectLocation]);

    // Load cart from localStorage when page opens
  useEffect(() => {
  const savedCart = localStorage.getItem("vendorCart");
  if (savedCart) {
    setCart(JSON.parse(savedCart));
  }
  }, []);
 
  // Save cart to localStorage whenever it changes
  useEffect(() => {
  localStorage.setItem("vendorCart", JSON.stringify(cart));
  }, [cart]);


  const filteredProducts = products.filter((p) => {
  return (
    p.category === selectedCategory &&
    (selectedSubCategory === "" ||
      p.subCategory === selectedSubCategory) &&
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
});


  const submitOrder = async () => {
  try {
   if (
  !checkoutData.name ||
  !checkoutData.phone ||
  !checkoutData.deliveryLocation?.address
) {
  alert("Please enter your mobile number and select your delivery location.");
  return;
}

    if (checkoutCart.length === 0) {
      alert("Cart is empty");
      return;
    }

    // 🔑 assume all items belong to same vendor
    const vendorId = checkoutCart[0]?.vendorId;

    if (!vendorId) {
  alert("Vendor ID missing. Please refresh and try again.");
  return;
}

   const total = checkoutCart.reduce((sum, item) => {
  if (item.productType === "RENTAL") {
    const daily = Number(item.dailyPrice) || 0;
    const qty = Number(item.quantity) || 1;
    const days = Number(item.days) || 1;
    return sum + daily * qty * days;
  }

  const price = Number(item.price) || 0;
  const qty = Number(item.quantity) || 1;
  return sum + price * qty;
}, 0);


    const res = await API.post(
  "/order",
      {
        customer: {
  name: checkoutData.name,
  phone: checkoutData.phone,
  email: checkoutData.email,

  deliveryLocation: {
    address: checkoutData.deliveryLocation.address,
    city: checkoutData.deliveryLocation.city,
    district: checkoutData.deliveryLocation.district,
    state: checkoutData.deliveryLocation.state,
    pincode: checkoutData.deliveryLocation.pincode,
    country: checkoutData.deliveryLocation.country,
    latitude: checkoutData.deliveryLocation.latitude,
    longitude: checkoutData.deliveryLocation.longitude,
  },
},
        cart: checkoutCart.map(item => ({
  productId: item._id,                 // internal
  vendorProductCode: item.vendorProductCode, // business ID
  name: item.name,
  productType: item.productType,
  price: item.productType === "SALE" ? item.price : undefined,
dailyPrice: item.productType === "RENTAL" ? item.dailyPrice : undefined,

  quantity: item.quantity,
  days:
    item.productType === "RENTAL"
      ? item.days
      : undefined
})),
        total,

          vendorId: vendorId, 
      
        
      }
    );

    if (!res.data.success) {
      alert("Order failed. Try again.");
      return;
    }

    // ✅ Open WhatsApp if backend sent link
    if (res.data.whatsappLink) {
      window.open(res.data.whatsappLink, "_blank");
    }

    alert("Order placed successfully");

    localStorage.setItem("customerPhone", checkoutData.phone);

    // ✅ Remove only the ordered vendor's products
const remainingCart = cart.filter(
  item => item.vendorId !== vendorId
);

setCart(remainingCart);

localStorage.setItem(
  "vendorCart",
  JSON.stringify(remainingCart)
);

setCheckoutCart([]);

setShowCheckout(false);

if (remainingCart.length === 0) {
  setShowCart(false);
}

  } catch (err) {
    console.error("Order submit error:", err);
    alert("Server error while placing order");
  }
};

const loadMyOrders = async () => {
  try {
    const res = await API.get("/customer/orders/my");

    setCustomerOrders(res.data.orders);
  } catch (err) {
    console.error("Load my orders failed", err);
  }
};

useEffect(() => {
  document.body.style.overflow = showMenu ? "hidden" : "";

  return () => {
    document.body.style.overflow = "";
  };
}, [showMenu]);

  return (
    <div className="vendor-page">
      {/* Top Bar */}
      <header className="vendor-header">
        <div className="vendor-left">
  <button
    className="vendor-menu-btn"
    onClick={() => setShowMenu(!showMenu)}
  >
    <Menu size={22} />
  </button>
  <div className="vendor-logo">
  <img src={logo} alt="Civilink" />
</div>

</div>


        <div className="vendor-search">
          <input
            type="text"
            placeholder="Search materials, vendors…"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="vendor-actions">
          <button
    className="vendor-location-pill"
    onClick={() => setShowLocationModal(true)}
>
    <MapPin size={18} />

    <span>
        {selectedLocation === "All India"
            ? "Select Location"
            : selectedLocation}
    </span>
</button>
          <button
           className="vendor-cart-btn"
          onClick={() => {
  if (!isLoggedIn) {
    window.location.href = "/";
    return;
  }
  setShowCart(true);
}}
>
           🛒
         {cart.length > 0 && (
            <span className="vendor-cart-badge">
         {cart.length}
        </span>
       )}

       </button>


        </div>
      </header>
      {showMenu && (
  <>
    <div
      className="vendor-drawer-overlay"
      onClick={() => setShowMenu(false)}
    />

    <div className="vendor-menu">
      

      <button
        className="vendor-menu-item"
        onClick={() => {
          setShowMenu(false);
          window.location.href = "/admin";
        }}
      >
        Admin Panel
      </button>

    

      <button
        className="vendor-menu-item"
        onClick={() => {
          if (!isLoggedIn) {
            window.location.href = "/";
            return;
          }

          setShowMenu(false);
          window.location.href = "/my-orders";
        }}
      >
        My Orders
      </button>

      <button
        className="vendor-menu-item"
        onClick={() => {
          setShowMenu(false);
          window.location.href = "/about";
        }}
      >
        About Civilink
      </button>

      <button
  className="vendor-menu-item"
  onClick={() => {
    setShowMenu(false);
    setShowContactPopup(true);
  }}
>
  <PhoneCall size={18} />
  <span>Contact Civilink</span>
</button>
    </div>
  </>
)}

      {/* Category Strip */}
      <div className="vendor-sticky-filters">

      <div className="vendor-categories">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            className={
              cat.id === selectedCategory
                ? "vendor-category active"
                : "vendor-category"
            }
            onClick={() => {
    setSelectedCategory(cat.id);
    setSelectedSubCategory("");
}}
          >
            {cat.label}
          </button>
        ))}
      </div>

     <SubCategorySlider
  products={products}
  selectedCategory={selectedCategory}
  selectedSubCategory={selectedSubCategory}
  setSelectedSubCategory={setSelectedSubCategory}
/>

</div>

{showLocationModal && (

<div className="vendor-modal-overlay">

<div className="location-modal">

<div className="location-header">

<h3>Choose Location</h3>

<button
onClick={() => setShowLocationModal(false)}
>
<X size={18}/>
</button>

</div>

<button
className="location-option"
onClick={() => {
  setAutoLocate(true);
  setShowLocationModal(false);
  setShowMapPicker(true);
}}
>

<Navigation size={18}/>

<div>

<strong>Use Current Location</strong>

<p>Find nearby vendors automatically</p>

</div>

</button>

<button
  className="location-option"
  onClick={() => {
  setAutoLocate(false);
  setShowLocationModal(false);
  setShowMapPicker(true);
}}
>
  <MapPinned size={18} />

  <div>
    <strong>Choose Project Location</strong>
    <p>Select your construction site on the map</p>
  </div>
</button>







</div>

</div>

)}

      


      {/* Info Banner */}
      <section className="vendor-banner">
        <h2>
          {selectedCategory === "raw" && "Raw Materials for Your Site"}
          {selectedCategory === "furniture" &&
            "Construction-Grade Furniture"}
          {selectedCategory === "electrical" &&
            "Safe & Reliable Electrical Materials"}
          {selectedCategory === "plumbing" &&
            "Plumbing Pipes & Fittings"}
          {selectedCategory === "concrete" && "Ready-Mix Concrete Supply"}
          {selectedCategory === "rental" &&
            "Rental Shuttering & Equipment"}
        </h2>
        <p>
          Showing best options{" "}
          {selectedLocation === "All India"
            ? "across all locations."
            : `available in ${selectedCity}.`}
        </p>
      </section>

      <main className="vendor-products">
  {filteredProducts.length === 0 ? (
    <div className="vendor-empty">
      No products found for this filter. Try another city or search term.
    </div>
  ) : (
    filteredProducts.map((p) => (
      <MarketplaceProductCard
        key={p._id}
        product={p}
        cart={cart}
        setCart={setCart}
        selectedVariants={selectedVariants}
        setSelectedVariants={setSelectedVariants}
        setShowAddedMsg={setShowAddedMsg}
        setSelectedProduct={setSelectedProduct}
      />
    ))
  )}
</main>

    {selectedProduct && (
  <div className="vendor-modal-overlay">
    <div className="vendor-modal">
      <div className="vendor-modal-header">
        <h3>{selectedProduct.name}</h3>
        <button
          className="vendor-modal-close"
          onClick={() => setSelectedProduct(null)}
        >
          ✕
        </button>
      </div>

      <div className="vendor-modal-body">
        {selectedProduct.imageUrl && (
          <img
            src={selectedProduct.imageUrl}
            alt={selectedProduct.name}
            className="vendor-product-image"
          />
        )}

        <p>
  <strong>Price:</strong>{" "}
  {selectedProduct.productType === "SALE" ? (
    selectedProduct.variants?.length ? (
      <>From ₹{Math.min(...selectedProduct.variants.map(v => v.price))}</>
    ) : (
      <>₹{selectedProduct.price}</>
    )
  ) : (
    <>From ₹{Math.min(...selectedProduct.variants.map(v => v.dailyPrice))} / day</>
  )}
</p>


        <p>
          <strong>Category:</strong>{" "}
          {selectedProduct.category}
        </p>

        <p>
          <strong>Vendor:</strong>{" "}
          {selectedProduct.vendor?.name}
        </p>

        <p>
          <strong>City:</strong> {selectedProduct.city}
        </p>

        <p className="vendor-modal-note">
          For bulk orders or negotiation, please contact admin.
        </p>
      </div>
    </div>
  </div>
)}  

 

  
  
  {showAddedMsg && (
    <div className="vendor-toast">
      ✅ Item added to cart
    </div>
  )}

{showCart && (
  <CartModal
    cart={cart}
    setCart={setCart}
    onClose={() => setShowCart(false)}
    onCheckout={(vendorItems) => {
  if (!isLoggedIn) {
    window.location.href = "/";
    return;
  }
  setCheckoutCart(vendorItems);
  setShowCart(false);
  setShowCheckout(true);
}}
  />
)}

{/* ✅ CHECKOUT MODAL */}
{showCheckout && (
  <CheckoutModal
    cart={checkoutCart}
    checkoutData={checkoutData}
    setCheckoutData={setCheckoutData}
    onBack={() => {
      setShowCheckout(false);
      setShowCart(true); // ✅ go back to cart
    }}
    onSubmit={submitOrder}  
  />

  )}

 {showMyOrders && (
  <section className="vendor-orders">
    <h3>My Orders</h3>

    {customerOrders.length === 0 ? (
      <p>No orders yet.</p>
    ) : (
      <table className="vendor-orders-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Customer</th>
            <th>Items</th>
            <th>Total</th>
            <th>Status</th>
            <th>Invoice</th>
          </tr>
        </thead>

        <tbody>
          {customerOrders.map(order => (
            <tr key={order._id}>
              <td>
                {new Date(order.createdAt).toLocaleString()}
              </td>

              <td>
                <strong>{order.customer.name}</strong>
              </td>

              <td>
                {order.items.map((i, idx) => (
                  <div key={idx}>
                    {i.name} × {i.quantity}
                  </div>
                ))}
              </td>

              <td>₹{order.total}</td>

              <td>{order.status || "Placed"}</td>

              <td>
                {order.invoiceUrl ? (
                  <a
                    href={order.invoiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </section>
)}

<LocationPicker
  autoLocate={autoLocate}
  open={showMapPicker}
  onClose={() => setShowMapPicker(false)}
  initialLocation={
  projectLocation.latitude
    ? projectLocation
    : null
}
  onSelect={(location) => {
    setProjectLocation(location);

    setSelectedLocation(location.city || location.address);

    setShowMapPicker(false);

    
  }}
/>
{showContactPopup && (
  <div
    className="vendor-modal-overlay"
    onClick={() => setShowContactPopup(false)}
  >
    <div
      className="contact-popup"
      onClick={(e) => e.stopPropagation()}
    >
      <button
  className="contact-popup-close"
  onClick={() => setShowContactPopup(false)}
>
  <X size={20} />
</button>
      <img
        src="/images/civilink-support.png"
        alt="Civilink Support"
        className="contact-popup-image"
      />

      <div className="contact-popup-content">
        <div className="contact-buttons">
          <a
            href="tel:+919344425095"
            className="contact-btn call"
          >
            <PhoneCall size={20} />
            <span>Call Now</span>
          </a>

          <a
            href="https://wa.me/919344425095?text=Hi%20Civilink,%20I%20need%20assistance."
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn whatsapp"
          >
            <MessageCircle size={20} />
            <span>WhatsApp</span>
          </a>

          <a
            href="mailto:civilink.official@gmail.com"
            className="contact-btn email"
          >
            <Mail size={20} />
            <span>Email</span>
          </a>

          <a
            href="https://instagram.com/civilink.official"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn instagram"
          >
            <Camera size={20} />
            <span>Instagram</span>
          </a>
        </div>
      </div>
    </div>
  </div>
)}
<BottomNavigation />

 
    </div>
  );
}


export default VendorDashboard;
